import "../../../design/iconSphere.css";
import { useEffect, useRef } from "react";
import TagCloud from "TagCloud";
import icon1 from "../../../assets/iconSphere/iconWithIconSphere/icon1.avif";
import icon2 from "../../../assets/iconSphere/iconWithIconSphere/icon2.avif";
import icon3 from "../../../assets/iconSphere/iconWithIconSphere/icon3.avif";

const importAll = (r) => r.keys().map(r);
const icons = importAll(
    require.context("../../../assets/iconSphere/iconSphereIcons", false, /\.svg$/)
);

export default function IconSphere() {
    const containerRef = useRef(null);
    const sphereRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const texts = icons.map((_, i) => `icon-${i}`);

        const createSphere = () => {
            const width = container.offsetWidth;

            let radius = Math.min(width / 2.5, 300);
            if (width < 500) radius = width / 2.2;
            if (width < 350) radius = width / 2;

            if (sphereRef.current) {
                container.innerHTML = "";
            }

            const options = {
                radius,
                maxSpeed: "fast",
                initSpeed: "fast",
                keep: true,
            };

            sphereRef.current = TagCloud(container, texts, options);

            setTimeout(() => {
                const items = container.querySelectorAll(".tagcloud--item");
                items.forEach((el, index) => {
                    el.innerHTML = `<img src="${icons[index]}" class="iconSphereItem" alt="tech-icon-${index}" />`;
                });
            }, 0);
        };

        createSphere();

        window.addEventListener("resize", createSphere);
        return () => {
            window.removeEventListener("resize", createSphere);
            if (container) container.innerHTML = "";
        };
    }, []);

    return (
        <section className="text-sphere">
            {/* Background Ambient Elements */}
            <div className="text-sphere-background">
                <img src={icon1} className="background-img bg1" alt="bg1" />
                <img src={icon2} className="background-img bg2" alt="bg2" />
                <img src={icon3} className="background-img bg3" alt="bg3" />
            </div>

            {/* Icon Sphere Engine */}
            <div className="sphere-wrapper">
                <span ref={containerRef} className="tagcloud"></span>
            </div>
        </section>
    );
}